import commonUtil from '../../../../utils/commonUtil';

export const GR_NEW_ADDRESS_LOAD = 'GR_NEW_ADDRESS_LOAD';
export const GR_NEW_ADDRESS_LOAD_SUCCESS = 'GR_NEW_ADDRESS_LOAD_SUCCESS';
export const GR_NEW_ADDRESS_LOAD_FAIL = 'GR_NEW_ADDRESS_LOAD_FAIL';
export const ADDRESS_SEARCH_LOAD = 'ADDRESS_SEARCH_LOAD';
export const ADDRESS_SEARCH_LOAD_SUCCESS = 'ADDRESS_SEARCH_LOAD_SUCCESS';
export const ADDRESS_SEARCH_LOAD_FAIL = 'ADDRESS_SEARCH_LOAD_FAIL';
export const FLUSH_ADDRESS_SEARCH = 'FLUSH_ADDRESS_SEARCH';
export const UPDATE_DELIVERY_ADDRESS = "UPDATE_DELIVERY_ADDRESS"

export function isGRNewAddressLoaded(globalState) {
  return globalState.giftRegistryNewAddress && globalState.giftRegistryNewAddress.loaded;
}

export function addUserAddressDetail(userDetail) {
  const userAddressData = Object.assign({}, userDetail);
  if (userAddressData.celebrityName) {
    delete userAddressData.celebrityName; // deleting celebrityName for Ecom service in event management
  }
  userAddressData.brand = commonUtil.getBrand().toUpperCase();
  userAddressData.channel = commonUtil.getChannel().toUpperCase();
  userAddressData.businessPhoneCode = '';
  userAddressData.businessPhoneNumber = '';
  userAddressData.particularPhoneCode = '';
  return commonUtil.triggerServerRequest({ url: '/api/currentUser/newDeliveryAddress', method: 'POST', data: userAddressData });
}

export function saveUserAddressDetail(userDetail) {
  const userAddressData = userDetail;
  userAddressData.brandName = commonUtil.getBrand().toUpperCase();
  userAddressData.channel = commonUtil.getChannel().toUpperCase();
  userAddressData.businessPhoneCode = '';
  userAddressData.businessPhoneNumber = '';
  userAddressData.particularPhoneCode = '';
  return commonUtil.triggerServerRequest({ url: '/api/currentUser/updateDeliveryAddress', method: 'POST', data: userAddressData });
}

export function getAddressData(userDetail) {
  const userAddressData = userDetail;
  userAddressData.brand = commonUtil.getBrand().toUpperCase();
  userAddressData.channel = commonUtil.getChannel().toUpperCase();
  return {
    types: [ADDRESS_SEARCH_LOAD, ADDRESS_SEARCH_LOAD_SUCCESS, ADDRESS_SEARCH_LOAD_FAIL],
    promise: client => client.post('/api/editEvent/addressSearch', {
      data: (userAddressData),
    }),
  };
}


export const flushAddressSearch = () => (dispatch, getState) => {
  const state = getState();
  const pageDate = state.giftRegistryNewAddress.data;
  // pageDate.data = {};
  Object.keys(pageDate).map((p) => {
    if (typeof pageDate[p] === 'object' && p !== 'data') {
      delete pageDate[p];
    }
    return undefined;
  });
  // dispatch(getSaveCreateEventData('pageName', pageDate));
  dispatch({
    type: FLUSH_ADDRESS_SEARCH,
    data: pageDate,
  });
};
export const updateDeliveryAddress = () => (dispatch,addressItem) => {
  dispatch({
    type: UPDATE_DELIVERY_ADDRESS,
    data: addressItem,
  });
};

